import { keyframes } from "styled-components";

const RollFromLeft = keyframes`
  from {
    transform: translateX(135%);
    opacity: 0;
  }

  to {
    transform: translateX(0)
    opacity: 1;
  }
`;

export default RollFromLeft;
